import { Translate } from '../translations';
import type { errorHandler } from '@wix/essentials';
import type { createDataExtensionSchema } from '@wix/bex-utils/@wix/ambassador-data-extensions-v1-data-extension-schema/http';

export const createDataExtensionSchemaErrors = ({
  translate: t,
}: {
  translate: Translate;
}): errorHandler.ErrorCodesMap<typeof createDataExtensionSchema> => {
  return {
    INVALID_NAMESPACE: () => ({
      message: t(
        'cairo.customFields.createDataExtension.invalid-namespace.error',
      ),
      action: {
        text: t('cairo.error.contactSupport.cta'),
        onClick: () => {},
      },
    }),
    FQDN_NOT_FOUND: () => ({
      message: t('cairo.customFields.createDataExtension.fqdn-not-found.error'),
      action: {
        text: t('cairo.error.contactSupport.cta'),
        onClick: () => {},
      },
    }),
    FQDN_NOT_EXTENSIBLE: () => ({
      message: t(
        'cairo.customFields.createDataExtension.fqdn-not-extensible.error',
      ),
      action: {
        text: '',
        onClick: () => {},
      },
    }),
  };
};
